<template>
  <div id="convertformats">
    <router-view />
  </div>
</template>

<style>
  @import "assets/stylesheets/base.css";
</style>
